import { useState, useEffect } from "react";

import { Button } from "@progress/kendo-react-buttons";
import { Input } from "@progress/kendo-react-inputs";
import clsx from "clsx";
import { useLocation, useNavigate } from "react-router-dom";

import SvgIcon from "../CustomeComponents/SvgIcon";

const AppHeader = ({ handleRishuiSearch, searchTaba, searchTikPikuah, seacrhHeytel }) => {
  const [systemCode, setSystemCode] = useState("");
  const [pathUrl, setPathUrl] = useState("");
  const [tikNumYear, setTikNumYear] = useState("");
  const [tikNumValue, setTikNumValue] = useState("");
  const [tabaTikNum, setTabaTikNum] = useState("");
  const [heytelTikNum, setHeytelTikNum] = useState("");
  const [heytelYearNum, setHeytelYearNum] = useState("");
  const [isActive, setIsActive] = useState(false);

  const search = useLocation().search;
  const pathname = useLocation().pathname;
  const navigate = useNavigate();

  useEffect(() => {
    console.log('pathname', pathname);
		const systemCodeURL = new URLSearchParams(search).get("SystemCode");
    setSystemCode(systemCodeURL);
    setPathUrl(pathname);
  }, [pathname]);

  useEffect(() => {
    const tikNumURL = new URLSearchParams(search).get("TikNum")
    switch (systemCode) {
      case '26400046': //Rishui
      case '26400056': //Pikuha
          if(tikNumURL !== null) {
            const tikNumArr = tikNumURL.split("/");
            setTikNumYear(tikNumArr[0]);
            setTikNumValue(tikNumArr[1]);
          }
          break;
      case '26400001': //Taba
        if(tikNumURL !== null) {
          setTabaTikNum(tikNumURL)
        }
        break;
      case '26400016': //Heytel
        if(tikNumURL !== null) {
          const tikNumArr = tikNumURL.split("/");
          setHeytelYearNum(tikNumArr[0]);
          setHeytelTikNum(tikNumArr[1]);
        }
        break;
    
      default:
        break;
    }
  }, [systemCode, pathname]);
  
  const changeTikNumYear = (e) => {
    const limitYear = 4;
    const input = e.target.value;
    // Remove non-numeric characters
    const sanitizedInput = input.replace(/[^0-9]/g, '');
    setTikNumYear(sanitizedInput.slice(0, limitYear));
  }

  const handleOnBlurYear = () =>{
    setIsActive(false);
    buildTikYearValue();
  }

  const buildTikYearValue = () => {
    let tikNum = systemCode !== "26400016" ? tikNumYear : heytelYearNum;
    if (tikNum) {
        let tikYear = "";
        let currYear = new Date().getFullYear();
        if (tikNum.length === 4 && parseInt(tikNum) <= currYear && parseInt(tikNum) >= 1920) {
            tikYear = tikNum;
        }
        if (tikNum.length === 4 && parseInt(tikNum) > currYear && parseInt(tikNum) < 1920) {
            alert("ערך שדה שנה לא תקין!");
        }
        if (tikNum.length > 0 && tikNum.length <= 2) {
            if (parseInt(tikNum) > currYear - 2000) {
                tikYear = (parseInt(tikNum) + 1900).toString();
            }
            else {
                tikYear = (parseInt(tikNum) + 2000).toString();
            }
        }
        
        if(systemCode !== "26400016") {
          setTikNumYear(tikYear);
        } else {
          setHeytelYearNum(tikYear);
        }

    } else { 
        if(systemCode !== "26400016") {
          setTikNumYear("2000");
      } else {
        setHeytelYearNum("2000");
      }
    }
  };

  const changeTikNumValue = (event) => {
    const input = event.target.value;
    // Remove non-numeric characters
    const sanitizedInput = input.replace(/[^0-9]/g, '');
    // Limit the input to 6 digits (4 + 2)
    const truncatedInput = sanitizedInput.slice(0, 6);
    // Format the number
    const formattedValue = formatNumber(truncatedInput);
    // Set the formatted value in the state
    setTikNumValue(formattedValue);
  };

  const formatNumber = (input) => {
    // Extract the first 4 digits
    const startNum = input.slice(0, 4);
    if(startNum === "") {
        return ""
    }
    // Extract the next 2 digits
    const endNum = input.slice(4, 6);
    // Create the formatted result
    const formattedNumber = `${startNum}.${endNum}`;
    return formattedNumber;
  };

  const handleOnBlurTikNum = () => {
    setIsActive(false);
    buildTikNumberValue();
  }

  const buildTikNumberValue = () => {
    let tikNum = tikNumValue;

    let tikNumber = "";
    let tik1 = "";
    let tik2 = "";
    
    if (tikNum === "" || tikNum === 0) {
      tikNumber = "0000.00";
    }
    if (tikNum && tikNumYear && tikNumYear.length === 0) {
        tikNumber = tikNum;
    }
    if (tikNumYear && tikNumYear.length === 4) {
        if (tikNum) {
            let pos = tikNum.indexOf(".");
            if (pos === -1) {
                tik2 = ".00";
                tik1 = tikNum;
            }
            else {
                tik1 = tikNum.slice(0, pos);
                tik2 = tikNum.slice(pos + 1);
                tik2 = "." + pad(tik2, 2);
            }
            tik1 = pad(tik1, 4);
            tikNumber = tik1 + tik2;
        }
        setTikNumValue(tikNumber);
    }
  };

  const pad = (str, max) => {
    str = str.toString();
    return str.length < max ? pad("0" + str, max) : str;
  }

  const changeTabaTikNum = (e) => {
    const tabaInput = e.target.value;
    // Remove non-numeric characters
    // const sanitizedInput = tabaInput.replace(/[^0-9]/g, '');
    setTabaTikNum(tabaInput)
  }

  const handleHeytelTikChange = (e) => {
    if (e.value !== undefined && e.value !== null && e.value !== "") {
      const input = e.value;
      // Remove non-numeric characters
      const sanitizedInput = input.replace(/[^0-9]/g, '');
      // Limit the input to 8 digits (5 + 3)
      const truncatedInput = sanitizedInput.slice(0, 8);
      // Format the number
      const formattedValue = formatHeytelNumber(truncatedInput);
      // Set the formatted value in the state
      setHeytelTikNum(formattedValue);
    }
  }

  const formatHeytelNumber = (input) => {
    // Extract the first 5 digits
    const startNum = input.slice(0, 5);
    if (startNum === "") {
      return ""
    }
    // Extract the next 3 digits
    const endNum = input.slice(5, 8);
    // Create the formatted result
    const formattedNumber = `${startNum}.${endNum}`;
    return formattedNumber;
  }

  const handleHeytelYearChange = (e) => {
    if(e.value !== undefined && e.value !== null && e.value !== "") {
        const limitYear = 4;
        const input = e.value;
        if(input !== "") {
            // Remove non-numeric characters
            const sanitizedInput = input.replace(/[^0-9]/g, '');
            setHeytelYearNum(sanitizedInput.slice(0, limitYear));
        } else {
            setHeytelYearNum("");
        }
    } else {
        setHeytelYearNum("");
    }
}

  const handleOnBlurHeytelTikNumber = () => {
    setIsActive(false);
    buildHeytelTikNumber();
  }

  const buildHeytelTikNumber = () => {
    let tikNum = heytelTikNum;

    let tikNumber = "";
    let tik1 = "";
    let tik2 = "";

    if (tikNum === "" || tikNum === 0) {
      tikNumber = "00000.000";
    }

    if (tikNum && tikNumYear && tikNumYear.length === 0) {
      tikNumber = tikNum;
    }

    if (tikNum) {
      let pos = tikNum.indexOf(".");
      if (pos === -1) {
        tik2 = ".000";
        tik1 = tikNum;
      } else {
        tik1 = tikNum.slice(0, pos);
        tik2 = tikNum.slice(pos + 1);
        tik2 = "." + pad(tik2, 3);
      }
      tik1 = pad(tik1, 5);
      tikNumber = tik1 + tik2;
    }

    setHeytelTikNum(tikNumber);
  }

  const searchTik = () => {
    if (systemCode === '26400046' || systemCode === '26400056') {
      const dataToSerach = {
        misparTik: `${tikNumYear}/${tikNumValue}`,
        gush: null,
        helka: null,
        rehovCode: null,
        rehovName: null,
        mispBait: null,
        mezahe: null,
        migrash: null,
        systemId: systemCode
      }

      if (systemCode === '26400046') {
        handleRishuiSearch(dataToSerach, "Header");
      } else {
        searchTikPikuah(dataToSerach, "Header");
      }
    } else if (systemCode === '26400001') {
      const tabaDataToSerach = {
        misparTaba: tabaTikNum,
        gush: null,
        helka: null,
        rehovCode: null,
        rehovName: null,
        mispBait: null,
        systemId: systemCode
      }
      searchTaba(tabaDataToSerach, "Header");
    } else {
      const heytelToSearch = {
        misparTik: `${heytelYearNum}/${heytelTikNum}`,
        asmahtaNum: null,
        tofesInternetNum: null
      }
      seacrhHeytel(heytelToSearch, "Header");
    }
  }

  return (
    <div className="main-header">
      <div className="container d-flex align-items-center justify-content-between">
        {/* <div className="main-header__title">{props.title}</div> */}
        <div className="">
          <div className="main-header__main-title">שירותים דיגטליים</div>
          <div className="page-header">
            {
              systemCode === "26400046" ?
                <div className="page-header__title">תיק רישוי בניה</div>
                :
                (
                  systemCode === "26400056" ?
                  <div className="page-header__title">תיק פיקוח בניה</div>
                  :
                  (
                    systemCode === "26400001" ?
                      <div className="page-header__title">תיק תב''ע</div>
                      :
                      <div className="page-header__title">תיק היטל השבחה</div>
                  )
                )
            }

            <div className="d-lg-none w-100"></div>

            {/* Form */}
            {
              pathUrl !== "/" && pathUrl !== "/TableData" & pathUrl !== "/TikimTaba" ? 
                <div className="page-header__form">
                  <div className={clsx({ 'case-form': true, 'is-active': isActive })}>
                    <div className="case-form__title">מס' תיק:</div>
                    {
                      systemCode === '26400046' || systemCode === '26400056' ?
                        <div>
                          <Input
                            type="text"
                            value={tikNumValue}
                            className="case-form__tik-1"
                            placeholder='xxxx.xx'
                            onChange={changeTikNumValue}
                            onKeyUp={(e) => e.key === 'Enter' && buildTikNumberValue()}
                            onFocus={() => setIsActive(true)}
                            onBlur={handleOnBlurTikNum}
                          />
                          <span className="case-form__divider text-secondary">/</span>
                          <Input
                            className="case-form__tik-2"
                            type="text"
                            value={tikNumYear}
                            placeholder='xxxx'
                            onChange={changeTikNumYear}
                            onKeyUp={(e) => e.key === 'Enter' && buildTikYearValue()}
                            onFocus={() => setIsActive(true)}
                            onBlur={handleOnBlurYear}
                          />
                        </div>
                        :
                        (
                          systemCode === '26400001' ? 
                            <div>
                              <Input
                                type="text"
                                value={tabaTikNum}
                                className="case-form__tik-1"
                                placeholder='xxxxxxx'
                                onChange={changeTabaTikNum}
                                onFocus={() => setIsActive(true)}
                                onBlur={() => setIsActive(false)}
                              />
                            </div>
                            :
                            <div>
                              <Input
                                type="text"
                                value={heytelTikNum}
                                className="case-form__tik-1"
                                placeholder='xxxxx.xxx'
                                style={{ width: '150px' }}
                                onChange={handleHeytelTikChange}
                                onFocus={() => setIsActive(true)}
                                onKeyUp={(e) => e.key === 'Enter' && buildHeytelTikNumber()}
                                onBlur={handleOnBlurHeytelTikNumber}
                              />
                              <span className="case-form__divider text-secondary">/</span>
                              <Input
                                className="case-form__tik-2"
                                type="text"
                                value={heytelYearNum}
                                placeholder='xxxx'
                                onChange={handleHeytelYearChange}
                                onFocus={() => setIsActive(true)}
                                onKeyUp={(e) => e.key === 'Enter' && buildTikYearValue()}
                                onBlur={handleOnBlurYear}
                              />
                            </div>
                        )
                    }
                    <Button themeColor={"primary"} type={"submit"}>
                      <SvgIcon icon="search" onClick={searchTik}/>
                    </Button>
                  </div>
                </div>
                :
                ""
            }

            {/* Home link */}
            <Button themeColor={"primary"} type={"button"} className="me-2" onClick={() => navigate(`/?SystemCode=${systemCode}`)}>
              <SvgIcon icon="home" />
            </Button>
          </div>
        </div>

        <div>
          <img
            className="main-header__logo"
            src={require("../assets/logo-new2.svg").default}
            alt="icon"
          />
        </div>
      </div>
    </div>
  )
}

export default AppHeader